var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 221,
    viewBox: "0 0 256 221",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M204.8 0H256L128 220.8L0 0H50.56H97.92L128 51.2L157.44 0H204.8Z",
    fill: "#41B883"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0L128 220.8L256 0H204.8L128 132.48L50.56 0H0Z",
    fill: "#41B883"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5605 0L128.001 133.12L204.801 0H157.441L128.001 51.2L97.9205 0H50.5605Z",
    fill: "#35495E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVue);
export default __webpack_public_path__ + "static/media/vue.5f5d16894e0a3def9502734973eb8eb5.svg";
export { ForwardRef as ReactComponent };